<template lang="pug">
  div
    .container-fluid.text-center(v-if='isLoading')
      Loading(:showMessages='true')

    .container-fluid.text-danger.text-center(v-if='!isLoading && showErrorMessage') {{ showErrorMessage }}

    template(v-if='!isLoading && !showErrorMessage')
      FacultyAssignment(v-if='useLegacyForm', :rawFacultyData='rawFacultyData', :facultyId='facultyId', :fromHome='fromHome', @make-dirty='makeDirty')
      FacultyAssignmentNew(v-else, :rawFacultyData='rawFacultyData', :facultyId='facultyId', :fromHome='fromHome', @make-dirty='makeDirty')
</template>

<script>
import { has } from 'lodash';
import watResource from '@api/wat/watResource';
import Loading from '@components/Loading';
import FacultyAssignment from './FacultyAssignment.vue';
import FacultyAssignmentNew from './FacultyAssignmentNew.vue';

const _ = { has };

// the last year to use the legacy form
const LEGACY_FORM_YEAR_MAX = 2023;

export default {
  name: 'FacultyAssignmentContainer',
  components: {
    FacultyAssignment,
    FacultyAssignmentNew,
    Loading
  },
  props: {
    facultyId: String,
    fromHome: Boolean
  },
  data: () => ({
    isLoading: false,
    showErrorMessage: null,
    formDirty: false,
    useLegacyForm: false,
  }),
  methods: {
    makeDirty: function (value) {
      this.formDirty = value;
    },
    onPageLeave: function (event) {
      if (this.formDirty) {
        event.preventDefault();
        event.returnValue = '';
      }
    },
    async init() {
      this.isLoading = true;
      try {
        this.rawFacultyData = await watResource.get(`api/w/facstaff/wat/${this.facultyId}`, null, null, this.$route.query);

        this.useLegacyForm = parseInt(this.rawFacultyData.REPORTING_YEAR) <= LEGACY_FORM_YEAR_MAX
      }
      catch (e) {
        console.error(e);
        if (_.has(e, 'body.message')) {
          this.showErrorMessage = e.body.message;
        }
        else {
          this.showErrorMessage = 'Whoops, there was an error loading the content.';
        }
      }
      finally {
        this.isLoading = false;
      }
    },
  },
  mounted: function () {
    window.addEventListener('beforeunload', this.onPageLeave);
  },
  beforeRouteLeave: function (_to, _from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    if (this.formDirty) {
      next(window.confirm('Are you sure you want to leave the page?  You have unsaved changes.  Please save your changes if you want to keep them.  Click Cancel to stay on the page.'));
    }
    else {
      next();
    }
  },
  created: function () {
    this.init();
  },
  beforeDestroy: function () {
    window.removeEventListener('beforeunload', this.onPageLeave);
  }
}
</script>